import React from 'react';
import PropTypes from 'prop-types';

export default function SummaryBlock({ title, content }) {
  if (!content) return null;

  return (
    <div className="mb-3">
      <h6>{title}</h6>
      <p>{content}</p>
    </div>
  );
}

SummaryBlock.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node // allows passing JSX too
  ])
};
